import React, { useState } from 'react'
import { Button, FormControl, Grid, TextField } from '@material-ui/core'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Table212 } from './Tables/TableSec2/Table212'
import { Table213 } from './Tables/TableSec2/Table213'
import { LoadingButton } from '@mui/lab'
import { useMonitoreo } from '../../../context/MonitoreoContext'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'
import ExitIcon from '@material-ui/icons/ExitToApp'
import SaveIcon from '@material-ui/icons/Save'
import ReactTooltip from 'react-tooltip'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { useFormMonitoringAndEvaluation } from '../../../context/MonitoringAndEvaluationContext'
import swal from 'sweetalert'
import {
  insertReportAnswers,
  uploadReportMonitoring,
  uploadReportMonitoringFinalTerm,
} from '../../../services/MonitoreoYEvaluacion/create'
import { useAuthentication } from '../../../context/authenticationContext'
import ROUTES from '../../../routers/routes'

export const MonitoreoSeccion2 = (props) => {
  const { goToStep, edit } = props
  const { userIDB2C } = useAuthentication()
  const { monitoringAndEvaluationForm } = useFormMonitoringAndEvaluation()
  const [, dispatch] = useMonitoreo()
  const history = useHistory()
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState({
    Progress_Impact_Indicator: false,
    Progress_Project_Execution: false,
    Challenges_Actions: false,
    Actions_Women_inclution: false,
    Social_EMP: false,
  })

  console.log('formulario de monitoreo', monitoringAndEvaluationForm)

  const GeneralDataSchema = Yup.object().shape({
    Progress_Impact_Indicator: Yup.string().required(
      'Este campo es obligatorio',
    ),
    Progress_Project_Execution: Yup.string().required(
      'Este campo es obligatorio',
    ),
    Challenges_Actions: Yup.string().required('Este campo es obligatorio'),
    Actions_Women_inclution: Yup.string().required('Este campo es obligatorio'),
    Social_EMP: Yup.string().required('Este campo es obligatorio'),
  })

  const formik = useFormik({
    validateOnChange: false,
    initialValues: {
      Progress_Impact_Indicator:
        monitoringAndEvaluationForm.Progress_Impact_Indicator || '',
      Progress_Project_Execution:
        monitoringAndEvaluationForm.Progress_Project_Execution || '',
      Challenges_Actions: monitoringAndEvaluationForm.Challenges_Actions || '',
      Actions_Women_inclution:
        monitoringAndEvaluationForm.Actions_Women_inclution || '',
      Social_EMP: monitoringAndEvaluationForm.Social_EMP || '',
      Indicator_Description:
        monitoringAndEvaluationForm?.Indicator_Description || '',
      // IdReportAnswer: monitoringAndEvaluationForm.IdReportAnswer,
    },
    validationSchema: GeneralDataSchema,
    onSubmit: (values) => {
      saveForm(values, false)
    },
  })

  const saveForm = async (values, borrador, exit) => {
    try {
      let object = values
      if (borrador) {
        object = {
          ...monitoringAndEvaluationForm,
          ...values,
        }
      } else {
        setSaving(true)
        object = {
          ...monitoringAndEvaluationForm,
          ...values,
          IdFormAction: 67,
          Draft: false,
        }
      }
      const response = await insertReportAnswers(object)

      if (response.Success) {
        if (borrador) {
          swal({
            title: 'Formulario Guardado',
            icon: 'success',
            button: 'Entendido',
          })

          if (exit) {
            if (edit) {
              history.push(ROUTES.IFIBORRADOR.pathname)
              dispatch({ type: 'SET_STATE', payload: 1 })
            } else {
              history.push('/')
              dispatch({ type: 'SET_STATE', payload: 1 })
            }
          }
          // Swal.fire({
          //   title: `Formulario Guardado

          //            <h4>¿Desea salir?</h4>`,
          //   icon: 'suceess',
          //   showCancelButton: true,
          //   confirmButtonColor: '#3085d6',
          //   cancelButtonColor: '#d33',
          //   confirmButtonText: 'Si',
          //   cancelButtonText: 'No',
          // }).then((result) => {
          //   if (result.isConfirmed) {
          //     createTest()
          //   } else {
          //     updateWorkshop(IdWorkshopStatus)
          //     history.push('/')
          //   }
          // })
        } else {
          uploadReport(
            response.Data.IdReportAnswer,
            response.Data.IdFormHistory,
          )
        }
      }
    } catch (error) {
      console.log('Error al guardar', error)
    }
  }

  const uploadReport = async (idForm, IdFormHistory) => {
    try {
      let response
      if (monitoringAndEvaluationForm.IdReportType === 7)
        response = await uploadReportMonitoring(
          idForm,
          userIDB2C,
          IdFormHistory,
        )
      else {
        response = await uploadReportMonitoringFinalTerm(
          idForm,
          userIDB2C,
          IdFormHistory,
        )
      }

      if (response.Success) {
        swal({
          title: 'Formulario Enviado Exitosamente',
          icon: 'success',
          button: 'Entendido',
        })
        history.push('/')
        setSaving(false)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const validateFormStatus = () => {
    formik
      .validateForm()
      .then((values) => {
        if (Object.entries(values).length === 0) {
          formik.submitForm()
        } else {
          alertValidationFields()
        }
      })
      .catch((error) => console.log('ERROR', error))
  }

  const alertValidationFields = () => {
    swal({
      title: 'Favor validar: si hay errores o campos pendientes por completar',
      icon: 'warning',
      button: 'Entendido',
    })
  }

  const setFormattedContent = (value, item) => {
    const words = value.split(' ')
    if (words.length <= 250) {
      if (
        value.match(
          /[-:.;,%#()"\w\sa-zA-ZÀ-ÿ\u00f1\u00d1]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1]*$/,
        ) ||
        value === ''
      ) {
        setError((prevState) => ({ ...prevState, [item]: false }))
        formik.setFieldValue(`${item}`, value)
      } else setError((prevState) => ({ ...prevState, [item]: true }))
    } else {
      formik.setFieldValue(`${item}`, words.slice(0, 250).join(' '))
    }
  }

  const previous = () => {
    dispatch({ type: 'SET_STATE', payload: 1 })
    goToStep(1)
  }

  const cancelForm = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Se perderán los datos no guardados',
      icon: 'warning',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      confirmButtonColor: '#3085d6',
      denyButtonText: `No guardar`,
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        saveForm(formik.values, true, true)
      } else if (result.isDenied) {
        if (edit) {
          history.push(ROUTES.IFIBORRADOR.pathname)
          dispatch({ type: 'SET_STATE', payload: 1 })
        } else {
          history.push('/')
          dispatch({ type: 'SET_STATE', payload: 1 })
        }
      }
    })
  }

  return (
    <>
      <Grid
        container
        md={12}
        sm={12}
        spacing={1}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Grid item>
          <div
            data-tip
            data-for="exitPop"
            onClick={() => cancelForm()}
            style={{
              backgroundColor: 'red',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <ExitIcon style={{ transform: 'scaleX(-1)' }} />
            <ReactTooltip id="exitPop" effect="solid" backgroundColor="red">
              <span>Regresar</span>
            </ReactTooltip>
          </div>
        </Grid>
        <Grid item>
          <div
            onClick={() => saveForm(formik.values, true)}
            data-tip
            data-for="savePop"
            style={{
              backgroundColor: '#5cb85c',
              color: '#fff',
              width: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              padding: '5px',
              cursor: 'pointer',
            }}
          >
            <SaveIcon />
          </div>
          <ReactTooltip id="savePop" effect="solid" backgroundColor="#5cb85c">
            <span>Guardar Borrador</span>
          </ReactTooltip>
        </Grid>
      </Grid>

      <form id="transfers-form">
        <div style={{ marginBottom: '48px' }}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '16px' }}
          >
            <Grid item md={12} sm={12} xs={12}>
              <div
                style={{
                  fontSize: '24px',
                  fontWeight: 'bold',
                  marginBottom: '8px',
                }}
              >
                <label className="formTitle">
                  Información sobre el avance de la implementación de la medida
                  de adaptación
                </label>
              </div>
              <label className="formDescription">
                Esta sección proporciona información general sobre la asistencia
                técnica solicitada
              </label>
            </Grid>
          </Grid>
        </div>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2.1. Avance de la implementación de la medida de adaptación
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1} style={{ marginBottom: '2%' }}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.1.1 Indicador de adaptación
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    id="IdCurrencyUser"
                    name="IdCurrencyUser"
                    style={{ width: '100%' }}
                    variant="outlined"
                    disabled
                    value={monitoringAndEvaluationForm.Indicator_Description}
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  2.1.2 Avance alcanzado en el indicador de impacto seleccionado
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Por favor, proporcione información sobre el avance
                      alcanzado en el indicador de impacto seleccionado
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      1. Informe narrativo del avance alcanzado (Máximo 250
                      palabras)
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Informe narrativo"
                        customInput={TextField}
                        value={formik.values.Progress_Impact_Indicator}
                        onChange={(e) => {
                          setFormattedContent(
                            e.target.value.trimStart(),
                            'Progress_Impact_Indicator',
                          )
                        }}
                      ></textarea>
                      {error.Progress_Impact_Indicator ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.Progress_Impact_Indicator ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.Progress_Impact_Indicator}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Adjunte documentos de respaldo: (Imágenes, facturas u
                      otros que considere importante)
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table212
                      IdReportAnswer={
                        monitoringAndEvaluationForm.IdReportAnswer
                      }
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography sx={{ fontWeight: 'bold' }}>
                  2.1.3 Avance alcanzado en la ejecución del subproyecto
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Por favor, proporcione información sobre el avance
                      alcanzado en la ejecución del subproyecto
                    </label>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    className="input__container"
                  >
                    <label className="responsiveLabel">
                      1. Informe narrativo del avance alcanzado (Máximo 250
                      palabras)
                      <span style={{ color: 'red' }}>*</span>
                    </label>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <FormControl style={{ width: '100%' }}>
                      <textarea
                        placeholder="Informe narrativo"
                        customInput={TextField}
                        value={formik.values.Progress_Project_Execution}
                        onChange={(e) => {
                          setFormattedContent(
                            e.target.value.trimStart(),
                            'Progress_Project_Execution',
                          )
                        }}
                      ></textarea>
                      {error.Progress_Project_Execution ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          Caracteres especiales no aceptados
                        </div>
                      ) : null}
                      {formik.errors.Progress_Project_Execution ? (
                        <div
                          style={{
                            color: 'red',
                            marginTop: '3px',
                            fontSize: '13px',
                          }}
                        >
                          {formik.errors.Progress_Project_Execution}
                        </div>
                      ) : null}
                    </FormControl>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} className="input__container">
                  <Grid item xs={12} sm={12} md={12}>
                    <label className="responsiveLabel">
                      Adjunte documentos de respaldo: (Imágenes, facturas u
                      otros que considere importante)
                    </label>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Table213
                      IdReportAnswer={
                        monitoringAndEvaluationForm.IdReportAnswer
                      }
                    />
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className="input__container"
              style={{ paddingTop: '2%' }}
            >
              <label className="responsiveLabel">
                2.1.4 Desafíos encontrados y acciones emprendidas para resolver
                (Máximo 250 palabras) <span style={{ color: 'red' }}>*</span>
              </label>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl style={{ width: '100%' }}>
                <textarea
                  placeholder="Desafios encontrados"
                  customInput={TextField}
                  value={formik.values.Challenges_Actions}
                  onChange={(e) => {
                    setFormattedContent(
                      e.target.value.trimStart(),
                      'Challenges_Actions',
                    )
                  }}
                ></textarea>
                {error.Challenges_Actions ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    Caracteres especiales no aceptados
                  </div>
                ) : null}
                {formik.errors.Challenges_Actions ? (
                  <div
                    style={{
                      color: 'red',
                      marginTop: '3px',
                      fontSize: '13px',
                    }}
                  >
                    {formik.errors.Challenges_Actions}
                  </div>
                ) : null}
              </FormControl>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{ fontWeight: 'bold' }}>
              2.2. Avances en la implementación de acciones orientadas a la
              inclusión de la mujer y en el Plan de Gestión Ambiental y Social
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.2.1 Acciones Orientadas a la inclusión de la mujer
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Proporcione información sobre las acciones revelantes
                  realizadas para incluir a la mujer en la MIPYME para el
                  período de reporte (Máximo 250 palabras){' '}
                  <span style={{ color: 'red' }}>*</span>
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Accciones orientadas la inclusión de la mujer"
                    customInput={TextField}
                    value={formik.values.Actions_Women_inclution}
                    onChange={(e) => {
                      setFormattedContent(
                        e.target.value.trimStart(),
                        'Actions_Women_inclution',
                      )
                    }}
                  ></textarea>
                  {error.Actions_Women_inclution ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.Actions_Women_inclution ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.Actions_Women_inclution}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} md={12} className="input__container">
                <label className="responsiveLabel">
                  2.2.2 Plan de Gestión Ambiental y Social
                </label>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <label className="responsiveLabel">
                  Describa las medidas de mitigación (si las hubiese) aplicadas
                  hasta el momento (Máximo 250 palabras){' '}
                </label>
                <span style={{ color: 'red' }}>*</span>
              </Grid>
              <Grid item xs={12} sm={12} md={12}>
                <FormControl style={{ width: '100%' }}>
                  <textarea
                    placeholder="Plan de Gestión Ambiental y Social"
                    customInput={TextField}
                    value={formik.values.Social_EMP}
                    onChange={(e) => {
                      setFormattedContent(
                        e.target.value.trimStart(),
                        'Social_EMP',
                      )
                    }}
                  ></textarea>
                  {error.Social_EMP ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      Caracteres especiales no aceptados
                    </div>
                  ) : null}
                  {formik.errors.Social_EMP ? (
                    <div
                      style={{
                        color: 'red',
                        marginTop: '3px',
                        fontSize: '13px',
                      }}
                    >
                      {formik.errors.Social_EMP}
                    </div>
                  ) : null}
                </FormControl>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>

        <Grid container spacing={1} className="button__container">
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'left' }}
            className="continerButtonNav"
          >
            <Button
              onClick={() => previous()}
              variant="contained"
              className="button__wizard button__previous"
            >
              Anterior
            </Button>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            style={{ textAlign: 'right' }}
            className="continerButtonNav"
          >
            <Grid container>
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: 'right' }}>
                <LoadingButton
                  loadingPosition="start"
                  variant="contained"
                  loading={saving}
                  className="button__wizard button__next"
                  onClick={() => validateFormStatus()}
                >
                  Registrar
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
